import { useAuthenticationStore } from '../stores'
import { solcloud } from '@/stores/solcloud'

export const useUserProfileQuery = () => {
  const authenticated = useAuthenticationStore((state) => !!state.authToken)
  const { data, refetch } = solcloud.useQuery('profile', undefined, { enabled: authenticated })

  return { profile: data?.account, refetch }
}
